import { BrowserRouter, Routes, Route } from "react-router-dom";

import NotFound from "../../screens/NotFound";
import Welcome from "../../screens/Welcome";
import Background from "../../screens/Background";
import TermsOfService from "../../screens/TermsOfService";

export default function Router() {  

  const isPreLaunch = false;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Background isPreLaunch={isPreLaunch} />}>           
           <Route index element={<Welcome />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
